import { BaseRepository } from "@common/data/base";

export interface Params {
  search: string;
  page: number;
  offset: number;
  limit: number;
}

export class BaseController<T> {
  constructor(
    protected repository: BaseRepository,
  ) {}

  get(params: any) {
    return this.repository.getRequest<T>(params);
  }

  getById(id: string) {
    return this.repository.getByIdRequest<T>(id);
  }

  getPaginated(params: Params) {
    return this.repository.getRequest<{ data: { results: T[], count: number }}>(params);
  }

  post(body: T) {
    return this.repository.postRequest<T>(body);
  }

  put(id: string, body: T) {
    return this.repository.putRequest<T>(id, body);
  }

  patch(id: string, body: T) {
    return this.repository.patchRequest<T>(id, body);
  }

  delete(id: string) {
    return this.repository.deleteRequest<T>(id);
  }
}